(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/containers/background.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/containers/background.js');
'use strict';

const HORIZON_POSITION_CLASSES = {
  high: 'js-triss-background--high',
  low: 'js-triss-background--low',
  medium: 'js-triss-background--medium'
};
const getHorizonClassName = function () {
  let imagePosition = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'high';
  return HORIZON_POSITION_CLASSES[imagePosition] || HORIZON_POSITION_CLASSES.high;
};
const Background = _ref => {
  let children = _ref.children,
    imagePosition = _ref.imagePosition;
  return React.createElement("div", {
    className: "triss-next-lobby js-triss-background ".concat(getHorizonClassName(imagePosition))
  }, children);
};
setGlobal('svs.tickets.next.containers.Background', Background);

 })(window);